<footer>
  <p>Ordenaris © {{currentYear}}</p>
  <p class="version">v{{version}}</p>
</footer>
